import skins from './skins'
import { skin } from 'Utils'
import Component from './component'

export default skin(Component, skins)
